(function (Drupal, $, once) {
  Drupal.behaviors.Calendar = {
    attach(context, settings) {
      once('Calendar', '.calendar-block', context).forEach(() => {
        const calendar = Cookies.get('events-calendar') || '#list-events';

        showCalendar(calendar);

        // Click handler
        $('.calendar-block ul.switch button').on('click', function () {
          const targetPanel = $(this).parent('li').attr('data-content');
          showCalendar(targetPanel);
        });

        // Keyboard navigation
        $('.calendar-block ul.switch button').on('keydown', function (e) {
          const $tabs = $('.calendar-block ul.switch button');
          const currentIndex = $tabs.index(this);
          let targetIndex;

          switch(e.key) {
            case 'ArrowLeft':
            case 'ArrowUp':
              e.preventDefault();
              targetIndex = currentIndex > 0 ? currentIndex - 1 : $tabs.length - 1;
              $tabs.eq(targetIndex).focus();
              break;
            case 'ArrowRight':
            case 'ArrowDown':
              e.preventDefault();
              targetIndex = currentIndex < $tabs.length - 1 ? currentIndex + 1 : 0;
              $tabs.eq(targetIndex).focus();
              break;
            case 'Home':
              e.preventDefault();
              $tabs.first().focus();
              break;
            case 'End':
              e.preventDefault();
              $tabs.last().focus();
              break;
          }
        });
      });

      function showCalendar(calendar) {
        const $li = $('.calendar-block ul.switch li[data-content="' + calendar + '"]');
        $li.addClass('active').siblings().removeClass('active');

        // Update ARIA states
        const $button = $li.find('button');
        $button.attr('aria-selected', 'true');
        $li.siblings().find('button').attr('aria-selected', 'false');

        // Show/hide panels
        $('.events-container').css('display', 'none').attr('hidden', 'hidden');
        $(calendar).css('display', 'block').removeAttr('hidden');

        // Save into cookie.
        Cookies.set('events-calendar', calendar);
      }
    }
  };
})(Drupal, jQuery, once);